import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { GridContainer, GridItem } from '@xing-com/grid';
import { Image } from '@xing-com/image';
import { Section } from '@xing-com/layout-primitives';
import {
  mediaConfined,
  mediaConfinedNavlessOnly,
  mediaSmallOnly,
  mediaSmallOrTiny,
  mediaTiny,
  mediaWideNavless,
  mediaXWide,
} from '@xing-com/layout-tokens';
import {
  scale100,
  scale150,
  scale250,
  space4XL,
  space6XL,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXXL,
  spaceXXS,
  xdlColorText,
} from '@xing-com/tokens';
import { Headline, Hero } from '@xing-com/typography';

import backgroundSmall from './assets/network-background-small.svg';
import networkImageSmallDE from './assets/network-image-small-de.svg';
import networkImageSmallEN from './assets/network-image-small-en.svg';

const CustomSection = styled(Section)`
  margin: ${scale250} 0;
  justify-content: center;
  overflow-x: hidden;

  @media ${mediaSmallOrTiny} {
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: ${spaceXXL};

    margin: 0;
    padding: 0;
  }

  @media ${mediaXWide} {
    padding: 0;
    width: 100vw;
  }
`;

const DiscoverButton = styled(Button)`
  width: fit-content;
`;

const GridContainerMargin = styled(GridContainer)`
  width: 100vw;

  @media ${mediaXWide} {
    width: 100vw;
  }
`;

const GridItemBackground = styled(GridItem)`
  @media ${mediaSmallOrTiny} {
    background-image: url(${backgroundSmall});
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: ${spaceXXL};
    background-position: 0 -${space4XL};
    height: 70%;
  }
`;

const GridItemRow = styled(GridItem)`
  display: flex;
  flex-direction: row;
  gap: ${spaceXXL};
  overflow: hidden;

  @media ${mediaXWide} {
    width: 100vw;
  }
`;

const HeadlineSmall = styled(Headline)`
  margin: ${spaceL} 0 ${spaceXL} 0;
  color: ${xdlColorText};
`;

const HeadlineWide = styled(Hero)`
  max-width: 630px;
  text-align: left;
  margin: 0;
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  flex-grow: 1;
`;

const InteractionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
  align-items: center;
  text-align: center;
  padding: ${spaceL};

  @media ${mediaConfined} {
    width: 100vw;
    gap: ${scale150};
    align-items: flex-start;
    margin: ${space6XL} 0;
    flex-grow: 1;
  }
`;

const NetworkImageSmall = styled.div<{ $isLocaleDE: boolean }>`
  ${({ $isLocaleDE }) =>
    $isLocaleDE
      ? `background-image: url(${networkImageSmallDE})`
      : `background-image: url(${networkImageSmallEN})`};

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 50%;
  @media ${mediaSmallOnly} {
    padding: 40%;
  }

  @media ${mediaTiny} {
    padding: 50%;
  }
`;

const NetworkImageWide = styled(Image)`
  height: 108%;
  padding: 0;
  margin: 0;

  @media ${mediaConfinedNavlessOnly} {
    height: 75%;
    margin-top: ${spaceXXS};
  }
`;

const ImageForeground = styled.div`
  position: absolute;
  left: -${scale100};
  bottom: -${spaceM};
  height: 100%;

  @media ${mediaWideNavless} {
    bottom: ${spaceM};
    height: 90%;
  }
`;

const BackgroundImageWide = styled(Image)`
  max-width: none;

  @media ${mediaConfinedNavlessOnly} {
    height: 75%;
  }
`;

const ImageBackground = styled.div`
  position: absolute;
  height: 50%;
  background-position: 25% 75%;

  @media ${mediaConfined} {
    height: 100%;
  }
`;

export const Styled = {
  DiscoverButton,
  GridContainerMargin,
  GridItemBackground,
  GridItemRow,
  HeadlineSmall,
  HeadlineWide,
  ImageContainer,
  InteractionContainer,
  NetworkImageSmall,
  NetworkImageWide,
  ImageForeground,
  BackgroundImageWide,
  ImageBackground,
  CustomSection,
};
